import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Layout } from "antd";
import PurchaseCandeFiMembershipPaymentStatus from "../purchase-candefi-membership-status";

const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_KEY}`);

const PurchaseCandeFiMembershipPaymentStatusPage = () => {
  return (
    <Layout>
      <Layout.Content>
        <Elements stripe={stripePromise}>
          <PurchaseCandeFiMembershipPaymentStatus />
        </Elements>
      </Layout.Content>
    </Layout>
  );
};

export default PurchaseCandeFiMembershipPaymentStatusPage;
